import Axios from '../../../_helpers/axiosHelper';
import {IDashboard} from "../reducers";

export const getDashboardInfo = (): Promise<IDashboard> => {
  return Axios.get('/dashboard');
};
